import PropTypes from 'prop-types';
import React from 'react';
import OffPathVideoEndCard from './OffPathVideoEndCard';
import OnPathEndCard from './OnPathEndCard';
import RestartVideoButton from './RestartVideoButton';

const dataId = 'video-end-screen';

const VideoEndscreen = props => {
  const { nextVideoTitle, nextVideoPoster, currentVideoTitle, fullScreenStyles } = props;
  let nextLessonCard = null;
  if (nextVideoTitle && nextVideoPoster !== null && nextVideoPoster !== undefined) {
    nextLessonCard = <OnPathEndCard {...props} dataId={dataId} />;
  } else if (currentVideoTitle) {
    nextLessonCard = <OffPathVideoEndCard {...props} dataId={dataId} />;
  }
  return (
    <div className="endscreen db relative aspect-ratio--16x9 z-2 bg-black">
      <div className="absolute w-100 h-100" style={fullScreenStyles}>
        <div className="absolute right-1 top-1">
          <RestartVideoButton {...props} dataId={dataId} />
        </div>
        <div className="flex justify-center h-100">{nextLessonCard}</div>
      </div>
    </div>
  );
};

VideoEndscreen.propTypes = {
  currentVideoTitle: PropTypes.string,
  fullScreenStyles: PropTypes.shape({}),
  nextVideoTitle: PropTypes.string,
  nextVideoPoster: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired,
};

VideoEndscreen.defaultProps = {
  currentVideoTitle: '',
  fullScreenStyles: null,
  nextVideoPoster: null,
  nextVideoTitle: null,
};

export default VideoEndscreen;
